import { useTranslation } from 'react-i18next'
import { SummaryIcon } from '@components/CartPage/CartWithItems/CartWithItems.styles'
import { DutiesDisclaimer } from '@components/DutiesDisclaimer/DutiesDisclaimer'
import { IsGiftOption } from '@components/IsGiftOption/IsGiftOption'
import { LockIcon } from '@velasca/icons/lock'
import { TagIcon } from '@velasca/icons/tag'
import { TruckIcon } from '@velasca/icons/truck'
import { SansText } from '@velasca/ui/sans-text'
import { $settings } from '@velasca/utils/globals'
import { Content, LineDescription, LineLabelsWrapper } from './Summary.styles'
import type { SummaryProps } from './Summary.types'

export const Summary = ({
  cartTotalPrice,
  setIsGiftOrder,
}: SummaryProps): JSX.Element => {
  const { t } = useTranslation('global')

  return (
    <Content>
      <LineDescription>
        <SansText>{t('cart_label_shipping')}</SansText>
        <SansText fontStyle="italic" color="primary">
          {t('shipping_fees')}
        </SansText>
      </LineDescription>

      <LineDescription>
        <SansText uppercase fontWeight="500" size="md">
          {t('cart_total_label')}
        </SansText>
        <SansText
          size="md"
          dangerouslySetInnerHTML={{
            __html: cartTotalPrice,
          }}
        />
      </LineDescription>

      <IsGiftOption setIsGiftOrder={setIsGiftOrder} />
      {$settings.show_duties_text && <DutiesDisclaimer />}

      <LineLabelsWrapper>
        <LineDescription
          css={`
            justify-content: flex-start;
            gap: 1.7rem;
          `}
        >
          <SummaryIcon>
            <TruckIcon />
          </SummaryIcon>
          <SansText
            size="md"
            dangerouslySetInnerHTML={{
              __html: t('cart_free_shipping'),
            }}
          />
        </LineDescription>
        <LineDescription
          css={`
            justify-content: flex-start;
            gap: 1.7rem;
          `}
        >
          <SummaryIcon>
            <TagIcon />
          </SummaryIcon>
          <SansText
            size="md"
            as="div"
            dangerouslySetInnerHTML={{ __html: t('cart_coupon') }}
          ></SansText>
        </LineDescription>
        <LineDescription
          css={`
            justify-content: flex-start;
            gap: 1.7rem;
          `}
        >
          <SummaryIcon>
            <LockIcon />
          </SummaryIcon>
          <SansText
            size="md"
            dangerouslySetInnerHTML={{
              __html: t('cart_secure_payment'),
            }}
          ></SansText>
        </LineDescription>
      </LineLabelsWrapper>
    </Content>
  )
}
